import React, {Suspense, useState} from "react";



// export const DEFAULT_URL = "http://localhost:8080/"
export const DEFAULT_URL = 'https://zest-survey-platform.ifi.uzh.ch/api/'
